import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function requiredDecimalValidator(minValue = 0): ValidatorFn {
  return (control: AbstractControl<string | number | null>): ValidationErrors | null => {
    const value = normalizeControlValue(control.value);
    if (value === null) {
      return { required: true };
    }

    const parsedValue = Number.parseFloat(value);
    if (!Number.isFinite(parsedValue)) {
      return { invalidNumber: true };
    }

    if (parsedValue < minValue) {
      return { minValue: { min: minValue, actual: parsedValue } };
    }

    return null;
  };
}

export function optionalDecimalValidator(minValue = 0): ValidatorFn {
  return (control: AbstractControl<string | number | null>): ValidationErrors | null => {
    const value = normalizeControlValue(control.value);
    if (value === null) {
      return null;
    }

    const parsedValue = Number.parseFloat(value);
    if (!Number.isFinite(parsedValue)) {
      return { invalidNumber: true };
    }

    if (parsedValue < minValue) {
      return { minValue: { min: minValue, actual: parsedValue } };
    }

    return null;
  };
}

function normalizeControlValue(value: string | number | null): string | null {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? `${value}` : null;
  }

  if (typeof value !== 'string') {
    return null;
  }

  const trimmedValue = value.trim();
  return trimmedValue.length > 0 ? trimmedValue : null;
}
